export const integrateSegment = (user) => {
  if (typeof globalThis.analytics != 'undefined' && user) {
    const userInfo = {
      role: user.role_uuid?.name ?? '',
      groupId: user.client,
      clientName: user.client_name,
      workflowAdmin: user.is_workflow_admin,
      roleType: user.role_uuid?.role_type ?? '',
      departments: (user.departments ?? []).join('; '),
      rolePermissions: (user.permission_names ?? []).join('; '),
    };
    globalThis.analytics.identify(`${user.id}_${user.client}`, userInfo);
  }
};

export const trackSegment = (name, properties) => {
  if (typeof globalThis.analytics != 'undefined') {
    globalThis.analytics.track(name, properties);
  }
};

export const trackPage = (properties) => {
  if (typeof globalThis.analytics != 'undefined') {
    if (properties && Object.keys(properties).length > 0) {
      globalThis.analytics.page(properties);
    } else {
      globalThis.analytics.page();
    }
  }
};
